module.exports = function (fox) {
	'use strict';
	
	return new fox.RSVP.Promise(function (resolve) {
		switch (fox.getEnv('public.area.title')) {
			case 'STUDIO_CRUSH_GIRLS':
				require.ensure([], function () {
					return resolve(require('./crush-girls')(fox));
				});
			break;
			case 'MCPROFITS_AREA':
				require.ensure([], function () {
					return resolve(require('./mcprofits')(fox));
				});
			break;
			case 'webmastercentro':
				require.ensure([], function () {
					return resolve(require('./webmastercentro')(fox));
				});
			break;
			default:
				resolve(true);
		}
	});
};


//////////////////
// WEBPACK FOOTER
// ./customizations/c11n-switcher.js
// module id = 171
// module chunks = 5